export const financeTypeSpecificContent = {
  pcp: {
    keyFeatures: [
      'Monthly payments are usually lower',
      'Hand the car back or trade it in',
      'Option to pay the final balloon payment to keep the vehicle',
      'Usually shorter contracts',
      'Mileage restrictions',
    ],
    needToKnow: {
      'Monthly payments':
        "Monthly payments are usually lower because there's a higher final payment at the end if you want to keep the car. Because payments are lower, you’re paying off less of the car’s value and the overall cost of borrowing is higher.",
      'At the end of your contract':
        'Hand the car back, trade it in or pay the optional final payment to own the car. This usually suits drivers who might want to change their car at the end of their agreement. HP might be a better option if you want to own the car at the end of your contract.',
      'Optional final payment':
        "Sometimes known as balloon payments or guaranteed future value (GFV). You'd need to make this payment to keep the car at the end of your contract.",
      'Contract length':
        'You can choose your contract term, but most people take finance over 3 or 4 years.',
      'Mileage restrictions and charges':
        'A mileage limit is set at the start of your contract. If you decide to hand the car back there’s a charge for driving more miles than agreed in your contract. ',
    },
  },
  hp: {
    keyFeatures: [
      'Monthly payments are usually higher',
      'You’ll own the car after making all the payments',
      'Usually 5 year contracts',
      'No mileage restrictions',
    ],
    needToKnow: {
      'Monthly payments':
        "Monthly payments are usually higher because you're paying off the full cost of the car. Your final payment will be lower because you're paying off more of the car's value during the contract.",
      'At the end of your contract':
        'You’ll own your car at the end of the contract if you make the final payment. This usually suits drivers who like to keep their car for longer. PCP might be a better option if you plan to change your car at the end of your contract.',
      'Completion fee':
        "You'll own the car when all payments and the completion or “option to purchase fee” are paid. In most cases, this costs £1 but will be detailed in your agreement.",
      'Contract length':
        'You can choose your contract term, but most people take finance over 4 or 5 years.',
      'No mileage restrictions':
        'There are no mileage restrictions for HP. Other finance options usually include a mileage limit in the contract.',
    },
  },
};

export const commonContent = {
  terms: {
    'Monthly payment':
      "This is how much you would pay to your lender each month whether it's through PCP or HP.",
    Deposit:
      'Unlike buying a car with cash or a bank loan, this is the amount you pay upfront towards the cost of your car. This can be a cash deposit or value from your part-exchange, if you have one.',
    'Total amount payable':
      'This is the total amount you’ll pay by taking finance.',
    'Fixed interest rate':
      'Fixed rates mean you know exactly how much you’ll pay each month. Interest rates will affect how much the loan will cost you overall.',
    'Representative APR':
      'APR means Annual Percentage Rate. This represents the cost of your agreement.',
    'Cash price':
      'How much this vehicle costs to buy outright. A helpful comparison when deciding if finance is right for you.',
    'Credit amount':
      'This is the amount you borrow minus your initial deposit or part-exchange.',
    'Annual & Contract mileage':
      'Choose this based on the miles you think you’ll drive per year or during your contract. This helps your lender value the vehicle at the end of your agreement.',
    'Excess mileage charge':
      "There's usually a charge per mile for driving more than agreed in your contract.",
    Term: 'This is how long your finance repayment period will be.',
    'Completion fee':
      "You'll pay a fee to complete your contract with the lender and take ownership of the vehicle.",
    'Optional final payment':
      "Sometimes known as balloon payments or guaranteed future value (GFV). You'd need to make this payment to keep the car at the end of your contract.",
  },
  faqs: {
    'Will I own the car?':
      'It depends. If you choose HP then after all payments are made the vehicle is yours. If you choose PCP then you’d need to pay the final payment (balloon payment or GFV) to settle the finance deal.',
    'What do I need?':
      'Your driving licence and an initial deposit if you don’t have a car to part-exchange.',
    'I’m in negative equity - can I still get finance?':
      'You still have options. Some lenders will supplement your deal with an unsecured loan or a hybrid agreement. We can also help you decide the best time to change your car.',
    'What about my credit score?':
      'We work with over 20 different lenders. Even if your credit score is a little lower, we may still be able to find the right lender for your circumstances.',
  },
};
